import React from 'react';
import PropTypes from 'prop-types';
import { HelpDeskInformation } from 'utils/types';
import css from './HelpDeskInfo.scss';
import StarfishHelpLink from './StarfishHelpLink';
import HelpPhone from './HelpPhone';
import HelpEmail from './HelpEmail';
import HelpWebsite from './HelpWebsite';
import { getWord } from 'utils/tenant';
import { isEmptyString } from 'utils/text';

/**
 * @returns {JSX.Element} The help desk information and link to Starfish help documentation
 */
function HelpDeskInfo({ helpDeskInformation, showStarfishHelpLink }) {
    const showTechnicalSupport = !(isEmptyString(helpDeskInformation.phone)
        && isEmptyString(helpDeskInformation.email)
        && isEmptyString(helpDeskInformation.url))

    return (
        <div className={css['help-resources']}>
            <h1>{helpDeskInformation.headerText || "What can we help you with?"}</h1>
            { showStarfishHelpLink &&
                <div className={css['section']}>
                    <h2>{helpDeskInformation.productHelpName || (getWord('Starfish', false) + ' Features')}</h2>
                    <StarfishHelpLink />
                </div>
            }
            { showTechnicalSupport &&
                <div className={css['section']}>
                    <h2>{helpDeskInformation.sectionTitle || 'Technical Support'}</h2>
                    <HelpPhone phone={helpDeskInformation.phone}/>
                    <HelpEmail email={helpDeskInformation.email}/>
                    <HelpWebsite supportWebsiteDisplayText={helpDeskInformation.supportWebsiteDisplayText}
                                 url={helpDeskInformation.url}/>
                </div>
            }
        </div>
    )
}

HelpDeskInfo.defaultProps = {
    showStarfishHelpLink: false
}

HelpDeskInfo.propTypes = {
    helpDeskInformation: HelpDeskInformation,
    showStarfishHelpLink: PropTypes.bool
}

export default HelpDeskInfo;
